'use client';
import React from 'react';
import { useSessionStorageEx } from '@/localShared/hooks/useSessionStorageEx';
import { useValidBackUrl } from '@/shared/hooks/useValidBackUrl';

export const PointChargeBackUrlSetter: React.FC = () => {
  const { backurl } = useValidBackUrl();
  const { setValue } = useSessionStorageEx('pointchargeQueryParams');

  React.useEffect(() => {
    // backurl クエリなしで来た場合は、古い backurl が残っていてもクリアする。
    // complete 画面の「次へ」ボタンで setValue(undefined) を呼ぶと、再レンダーで
    // 遷移先・UI が変わってしまうため、クリアのタイミングを次回 pointcharge 訪問時に集約する。
    if (!backurl) {
      setValue(undefined);
      return;
    }

    setValue({ backurl });
  }, [backurl, setValue]);

  return null;
};
